import React, { useState, useEffect, Fragment, useContext } from "react";
import Location from "components/sales/formSection/location/locationOnboarding";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import BulkUpload from "components/sales/bulkUpload/bulkUpload";
import Layout from 'components/sales/layout/layout';
import CardSection from 'components/sales/cardSection/cardSection';
import SearchLocation from 'components/sales/searchLocation/searchLocation';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DivLayout from 'components/sales/divLayout/divLayout';
import { toast } from "react-toastify";

const BusinessChange = ({ match, getAddressBusiness, setAddressBusiness, businessDetails }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [data, setData] = useState({address_id:null, lead_id:parseInt(match.params.lead_id), comm_id:parseInt(match.params.comm_id)})

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAddressBusiness(match.params.lead_id, match.params.comm_id)
            setIsLoading(false)
        })()
    }, [])

    const handleSubmit = (master=false) => {
        if (data?.address_id == null) {
            toast.error('Map Address')
            return;
        }
        else {
            (async () => {
                setIsLoading(true)
                if(master == true){
                    data.make_master = master;
                }
                const res = await setAddressBusiness(data)
                if (res?.status_code !== 500) {
                    setIsModal(true)
                }
                else {
                    toast.error(res?.message)
                }
                setIsLoading(false)
            })()
        }
    }

    useEffect(()=>{
        if(data?.address_id != null && data?.make_master == true){
            handleSubmit(data?.make_master);
        }
        else if(data?.address_id != null){
            handleSubmit();
        }
    },[data?.address_id])

    return (
        <Layout
            title={localization.contractListing}
            isGoback
            isLoading={isLoading}
        >
            {businessDetails && businessDetails.map((value, index) => {
                return (
                    <CardSection title={localization.address + ' ' + (index + 1)} key={index}
                    clsName={value?.contract_mapping_type === "MASTER" ? 'mh2' : ''} 
                    status = {value?.contract_mapping_type}
                    >
                        <div className="details-listing">
                            <DivLayout
                                heading={localization.addressLine1}
                                data={value.address_line_1}
                            />
                            <DivLayout
                                heading={localization.addressLine2}
                                data={value.address_line_2}
                            />
                            <DivLayout
                                heading={localization.city}
                                data={value.city_name}
                            />
                            <DivLayout
                                heading={localization.state}
                                data={value.state_name}
                            />
                            <DivLayout
                                heading={localization.pinCode}
                                data={value.pincode}
                            />
                            <DivLayout
                                heading={localization.addressCreatedBy}
                                data={value.name}
                            />

                            {value.contract_mapping_id  && value.contract_mapping_id > 0 ? (
                            <>
                                <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                                    <button className='btn btn-primary btn-green-v2' disabled={true}>Mapped</button>
                                </div>
                                {
                                (value.contract_mapping_type == 'OTHER') && 
                                <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                                    <button onClick={() => { setData({ ...data, address_id: value.id, make_master:true }); }} className='btn btn-primary btn-red'>Map Master Business Address</button>
                                </div>
                                }
                                </>
                            )
                            :
                            <div className='col-md-12' style={{ 'padding': '15px 0px 15px 0px' }}>
                                <button onClick={() => { setData({ ...data, address_id: value.id }); }} className='btn btn-primary btn-red'>Map Business Address</button>
                            </div>
                            }
                        </div>
                    </CardSection>)
            })

            }

            <ModalPop
                title=""
                show={isModal}
                handleModalHide={() => { setIsModal(false); window.location.href = `${baseUrl}/finance-contract-listing` }}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>Business Changed Successfully</h5>
                    <Link to={`${baseUrl}/finance-contract-listing`} className="btn btn-primary mb-4">View Contract Listing</Link>
                </div>
            </ModalPop>
        </Layout>
    )
}

export default BusinessChange